import Vue from 'vue'
import Router from 'vue-router'
import Home from "../components/Home.vue"
import Index from "../components/Index.vue"
// import Index1 from "../components/Index1.vue"
import Login from "../components/Login.vue"
import SaleQuery from "../pages/SaleQuery.vue"
import StoreQuery from "../pages/StoreQuery.vue"
import SaleCheck from "../pages/SaleCheck.vue"
import GoodsCheck from "../pages/GoodsCheck.vue"
import SettlementQuery from "../pages/SettlementQuery.vue"
import NearlyGoods from "../pages/NearlyGoods.vue"
import StoreOverDue from "../pages/StoreOverDue.vue"
import GoodsForward from "../pages/GoodsForward.vue"
import ClerkInStore from "../pages/ClerkInStore.vue"
import Endregion from "../pages/Endregion.vue"
import FactoryInStore from "../pages/FactoryInStore.vue"
import FactorySale from "../pages/FactorySale.vue"
import FactoryStore from "../pages/FactoryStore.vue"
import clerkInStore from "../pages/ClerkInStore.vue"
import Region from "../pages/Region.vue"
import Approve from "../components/Approve.vue"
import Unbind from "../components/Unbind.vue"
import StateMent from "../pages/Statement.vue"
import StorePj from "../pages/Pj/StorePj.vue"

import FactStore from "../pages/vender/FactStore.vue"
import FactSales from '../pages/vender/FactSales.vue'
import FactoryEnterDetail from "../pages/vender/FactoryEnterDetail.vue"
import MyM from "../pages/MyM.vue"
import news from "../pages/news.vue"
import newsList from "../pages/newsList.vue"
import MoreMessage from "../pages/MoreMessage.vue"
import Plan from '../pages/Plan.vue'
import NewPlan from '../pages/NewPlan.vue'
import Query from '../pages/Query.vue'
import Password from "../components/password.vue"
import Secondpass from "../components/secondpass.vue"
import NetworkError from "../components/NetworkError.vue"
import MyLog from "../pages/MyLog.vue"
import Favorite from "../pages/Favorite.vue"
import GetLog from "../pages/getLog.vue"
import ChangeLog from "../pages/MyLog/ChangeLog.vue"
import AddLog from "../pages/MyLog/AddLog.vue"
import Replay from "../pages/MyLog/Replay.vue"
import Revert from "../pages/MyLog/Revert.vue"
import LookLog from "../pages/MyLog/LookLog.vue"
import UploadPictures from "../pages/Endregion/UploadPictures.vue"
import UpLoadImage from "../pages/Endregion/UpLoadImg.vue"
import OutStandingTax from "../pages/Tax/OutStandingTax.vue"
import WareHousing from "../pages/Tax/WareHousing.vue"
import BalanceDue from "../pages/BalanceDue.vue"
import HospitalMoney from "../pages/HospitalMoney.vue"
import PutStorage from "../pages/PutStorage.vue"
import ywyUpload from '../pages/ywyUpload.vue'
import hdtj from '../pages/hdtj.vue'
import hdpz from '../pages/hdpz.vue'
import cxhz from '../pages/cxhz.vue'


import InventoryStatistics from "../pages/manager/InventoryStatistics.vue"
import NewCustomer from "../pages/manager/NewCustomer.vue"
import SalesQuery from '../pages/manager/SalesQuery.vue'
import StorageRecord from "../pages/manager/StorageRecord.vue"
import LogReview from "../pages/manager/LogReview.vue"
import Inventory from "../pages/manager/Inventory.vue"

import LossingCustomer from "../pages/manager/LossingCustomer.vue"
import SalesGournal from '../pages/manager/SalesGournal.vue'
import RegionalSales from '../pages/manager/RegionalSales.vue'
import SalesYearonYear from "../pages/manager/SalesYearonYear.vue"
import SalesSummary from "../pages/manager/SalesSummary.vue"
import OrderInquiry from "../pages/manager/OrderInquiry.vue"
import Logistics from "../pages/manager/Logistics.vue"



import DownLoadApp from "../components/DownLoadApp.vue"
import LhSaleQuery from "../pages/Lihui/LhSaleQuery.vue"
import ZxSaleQuery from "../pages/Lihui/ZxSaleQuery.vue"
import LhStoreQuery from '../pages/Lihui/LhStoreQuery.vue'
import ZxStoreQuery from '../pages/Lihui/ZxStoreQuery.vue'
import ZxInventory from "../pages/Lihui/ZxInventory.vue"
import ZxOrderInquiry from "../pages/Lihui/ZxOrderInquiry.vue"
import Zxplan from "../pages/Lihui/ZxPlan.vue"
import PriceAjustment from '../pages/PriceAdjustment.vue'
import PricingManagement from '../pages/PricingManagement.vue'
import RankingList from '../pages/RankingList.vue'
import AdjustRecord from "../pages/Record/AdjustRecord.vue"
import MoveRecord from "../pages/Record/MoveRecord.vue"
import RebateInformation from "../pages/RebateInformation.vue"
import LatestSale from "../pages/manager/LatestSale.vue"
import WeeklyReport from "../components/weeklyReport/WeeklyReport.vue"
import ChangeWeek from "../components/weeklyReport/ChangeWeek.vue"
import AddWeek from "../components/weeklyReport/AddWeek.vue"
import WeekCheck from "../components/weeklyReport/WeekCheck.vue"
import BillingInformation from "../pages/BillingInformation.vue"
import Schedule from "../pages/Schedule.vue"
import OrderManagement from "../pages/OrderManagement.vue"
import Monthly from "../components/monthly/monthly.vue"
import MonthyReview from "../components/monthly/monthyReview.vue"
import AddMonthly from "../components/monthly/AddMonthly.vue"
import ChangeMonthly from "../components/monthly/ChangeMonthly.vue"

import SummaryMeeting from "../pages/Meeting/SummaryMeeting.vue"
import AddMeeting from "../pages/Meeting/AddMeeting.vue"
import CheckMeeting from "../pages/Meeting/CheckMeeting.vue"
import SuperviseMeeting from "../pages/Meeting/SuperviseMeeting.vue"
import LookMeeting from "../pages/Meeting/LookMeeting.vue"
import ChangeMeeting from "../pages/Meeting/ChangeMeeting.vue"
import LihuiMeeting from "../pages/Meeting/LihuiMeeting.vue"
import Evaluate from "../pages/Pj/Evaluate.vue"
import EvaluateAll from "../pages/Pj/EvaluateAll.vue"
import NewEvaluate from "../pages/Pj/NewEvaluate.vue"
import Forum from "../pages/Forum/forum.vue"
import AddForum from "../pages/Forum/AddForum.vue"
import ChangeForum from "../pages/Forum/ChangeForum.vue"
import LookForum from "../pages/Forum/LookForum.vue"
import MinRevert from "../pages/Forum/MinRevert.vue"

import Yssm from "../pages/Yssm.vue"
import BusinessLog from "../pages/BusinessLog/BusinessLog.vue"
import BaddLog from "../pages/BusinessLog/BaddLog.vue"
import BLookLog from "../pages/BusinessLog/BLookLog.vue"

import Accounts from "../pages/Administrator/Accounts.vue"
import HaveAccount from "../pages/Administrator/HaveAccount.vue"
import CheckAccount from "../pages/Administrator/CheckAccount.vue"
import Examination from "../components/Examination.vue"
import TestQuestions from "../components/TestQuestions.vue"
import Practice from '../components/Practice.vue'
import Online from "../components/Online.vue"
import Questions from "../components/Questions.vue"
import Answer from "../components/Answer.vue"
import QueryScore from "../components/QueryScore.vue"
import AnswerDetail from "../components/AnswerDetail.vue"
import Activity from '../components/Activity.vue'
import SeckillDrug from "../components/SeckillDrug.vue"

import Video from "../components/Video.vue"
import Practicelog from "../components/Practicelog.vue"
import Gopdf from "../components/Gopdf.vue"
import TgDrug from "../components/TgDrug.vue"
import ByDrug from "../components/ByDrug.vue"
import TgOrder from "../components/TgOrder.vue"
import WarehousingManage from "../pages/WarehousingManage.vue"
import newActivity from '../pages/newActivity.vue'
import stockQuery from '../pages/stock.vue'
import complaint from '../pages/complaint.vue'
import managerComplaint from '../pages/managerComplaint.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home', component: Home,
      children: [{
        path: '/storeQuery',
        component: StoreQuery,
      },
      {
        path: "/index",
        component: Index,
      },
      {
        path: "/saleQuery",
        component: SaleQuery
      },
      {
        path: "/goodsCheck",
        component: GoodsCheck
      },
      {
        path: "/saleCheck",
        component: SaleCheck
      },
      {
        path: "/settlementQuery",
        component: SettlementQuery
      },
      {
        path: "/nearlyGoods",
        component: NearlyGoods
      },
      {
        path: "/storeOverDue",
        component: StoreOverDue
      },
      {
        path: "/goodsForward",
        component: GoodsForward
      },
      {
        path: "/endregion",
        component: Endregion
      },
      {
        path: "/clerkInStore",
        component: ClerkInStore
      },
      {
        path: "/storePj",
        component: StorePj
      },
      {
        path: "/factoryInStore",
        component: FactoryInStore
      },
      {
        path: "/factorySale",
        component: FactorySale
      },
      {
        path: "/factoryStore",
        component: FactoryStore
      },
      {
        path: '/clerkinStore',
        component: clerkInStore
      },
      { path: '/statement', component: StateMent },
      { path: '/region', component: Region },
      { path: '/factStore', component: FactStore },
      { path: '/factSales', component: FactSales },
      { path: '/factoryEnterDetail', component: FactoryEnterDetail },
      { path: '/myM', component: MyM },
      { path: '/news', component: news },
      { path: '/newsList', component: newsList },
      { path: "/moreMessage", component: MoreMessage },
      { path: "/plan", component: Plan },
      { path: "/drugQuery", component: Query },
      { path: '/password', component: Password },
      { path: '/secondpass', component: Secondpass },
      {
        path: '/myLog',
        component: MyLog,
        // meta:{
        //   keepAlive:true
        // },
      },
      { path: '/changeLog', component: ChangeLog },
      { path: '/addLog', component: AddLog },
      { path: '/getLog', component: GetLog },
      { path: '/uploadPictures', component: UploadPictures },
      { path: '/upLoadImage', component: UpLoadImage },
      { path: '/salesQuery', component: SalesQuery },
      { path: '/newCustomer', component: NewCustomer },
      { path: '/storageRecord', component: StorageRecord },
      { path: '/logReview', component: LogReview },
      { path: '/inventory', component: Inventory },
      { path: '/ZxInventory', component: ZxInventory },
      { path: '/Zxplan', component: Zxplan },
      { path: '/ZxOrderInquiry', component: ZxOrderInquiry },
      { path: '/replay', component: Replay },
      { path: '/revert', component: Revert },
      { path: '/salesGournal', component: SalesGournal },
      {
        path: '/looklog',
        component: LookLog,
        // meta:{
        //   keepAlive:true
        // }
      },
      { path: '/lossingCustomer', component: LossingCustomer },
      { path: '/downLoadApp', component: DownLoadApp },
      { path: '/lhSaleQuery', component: LhSaleQuery },
         { path: '/ZxSaleQuery', component: ZxSaleQuery },
      { path: '/lhStoreQuery', component: LhStoreQuery },
      { path: '/ZxStoreQuery', component: ZxStoreQuery },
      { path: '/priceAdjustment', component: PriceAjustment,
      meta: {
        noCache: true
        } },
      { path: '/pricingManagement', component: PricingManagement },
      { path: '/rankingList', component: RankingList },
      { path: '/adjustRecord', component: AdjustRecord },
      { path: "/moveRecord", component: MoveRecord },
      { path: "/rebateInformation", component: RebateInformation },
      { path: "/latestSale", component: LatestSale },
      { path: "/weeklyReport", component: WeeklyReport },
      { path: "/changeWeek", component: ChangeWeek },
      { path: "/addweek", component: AddWeek },
      { path: "/weekCheck", component: WeekCheck },
      { path: "/outStandingTax", component: OutStandingTax },
      { path: "/wareHousing", component: WareHousing },
      { path: "/inventoryStatistics", component: InventoryStatistics },
      { path: "/billingInformation", component: BillingInformation },
      { path: "/schedule", component: Schedule },
      { path: "/orderManagement", component: OrderManagement },
      { path: "/monthly", component: Monthly },
      { path: "/monthyReview", component: MonthyReview },
      { path: "/addMonthly", component: AddMonthly },
      { path: "/changeMonthly", component: ChangeMonthly },
      { path: "/balanceDue", component: BalanceDue },
      { path: "/hospitalMoney", component: HospitalMoney },
      { path: "/favorite", component: Favorite },
      { path: "/regionalSales", component: RegionalSales },
      { path: "/putStorage", component: PutStorage },
      { path: "/salesYearonYear", component: SalesYearonYear },
      { path: "/summaryMeeting", component: SummaryMeeting },
      { path: "/addMeeting", component: AddMeeting },
      { path: "/checkMeeting", component: CheckMeeting },
      { path: "/superviseMeeting", component: SuperviseMeeting },
      { path: "/lookMeeting", component: LookMeeting },
      { path: "/changeMeeting", component: ChangeMeeting },
      { path: "/lihuiMeeting", component: LihuiMeeting },
      { path: "/evaluate", component: Evaluate },
      { path: "/newevaluate", component: NewEvaluate },
      { path: "/evaluateAll", component: EvaluateAll },
      { path: "/forum", component: Forum },
      { path: "/addForum", component: AddForum },
      { path: "/changeForum", component: ChangeForum },
      {
        path: "/lookForum", component: LookForum,
        // meta: {
        //   requireAuth: true,
        //   keepAlive: true, //此组件不需要被缓存
        // },

      },
      { path: "/minrevert", component: MinRevert },
      {
        path: "/businessLog",
        component: BusinessLog,
      },
      {
        path: "/BaddLog",
        component: BaddLog,
      },
      {
        path: "/BLookLog",
        component: BLookLog,
      },
      {
        path: "/salesSummary",
        component: SalesSummary,
      },
      {
        path: "/accounts",
        component: Accounts,
      },
      {
        path: "/haveaccount",
        component: HaveAccount,
      },
      {
        path: "/checkAccount",
        component: CheckAccount,
      },
      {
        path: "/orderInquiry",
        component: OrderInquiry,
      },
      {
        path: "/logistics",
        component: Logistics,
      },
      {
        path: "/examination",
        component: Examination,
      },
      {
        path: "/testQuestions",
        name: 'testQuestions',
        component: TestQuestions,
      },
      {
        path: "/practice",
        component: Practice
      },
      {
        path: "/online",
        component: Online
      }, {
        path: "/questions",
        component: Questions
      }
        , {
        path: "/answer",
        component: Answer
      }
        , {
        path: "/queryscore",
        component: QueryScore
      }
        , {
        path: "/answerdetail",
        component: AnswerDetail
      },
      {
        path: "/activity",
        component: Activity
      },
      {
        path: "/seckillDrug",
        name: 'seckillDrug',
        component: SeckillDrug
      },
      {
        path: "/video",
        component: Video
      },
      {
        path: "/practicelog",
        component: Practicelog
      },
      {
        path: "/gopdf",
        component: Gopdf
      },
      {
        path: "/tgDrug",
        name: 'tgDrug',
        component: TgDrug
      },
      {
        path: "/byDrug",
        name: 'byDrug',
        component: ByDrug
      },
      {
        path: "/tgorder",
        component: TgOrder
      },
      {
        path: "/warehousingmanage",
        component: WarehousingManage
      },
      {
        path: "/stockQuery",
        component: stockQuery
      },
      {
        path: "/pjList",
        component: () => import('../pages/Pj/getAllPjList.vue')
      },
      {
        path: "/bmpj",
        component: () => import('../pages/Pj/addBmPj.vue')
      },
      {
        path: "/complaint",
        component: complaint
      },
      {
        path: "/managerComplaint",
        component: managerComplaint
      },
      {
        path: "/newActivity",
        component: newActivity
      },
      {
        path: "/fybx",
        component: () => import('../pages/Sh/fybx.vue')
      },
      {
        path: "/bxsh",
        component: () => import('../pages/Sh/bxsh.vue')
      },
      {
        path: "/ywyUpload",
        component: ywyUpload
      },
      {
        path: "/hdtj",
        component: hdtj
      },
      {
        path: "/hdpz",
        component: hdpz
      },
      {
        path: "/cxhz",
        component: cxhz
      }
      ]
    },
    { path: "/", component: Login },
    { path: '/approve', component: Approve },
    { path: '/unbind', component: Unbind },
    { path: '/networkerror', component: NetworkError },
    {
      path: "/yssm",
      component: Yssm,
    }
  ],
  mode: "history"
})



// WEBPACK FOOTER //
// ./src/router/index.js